import { HomePageLayoutBlueprint } from '@backstage/plugin-home-react/alpha';
import { CustomHomepageGrid } from '@backstage/plugin-home';
import { Header, Page, Content } from '@backstage/core-components';
import { Fragment, useEffect, useState } from 'react';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';

export const xxHomePageLayout = HomePageLayoutBlueprint.make({
  name: 'xx-layout',
  params: {
    loader: async () =>
      function XxHomePageLayout({ widgets }) {
        const identityApi = useApi(identityApiRef);
        const [displayName, setDisplayName] = useState('');

        useEffect(() => {
          identityApi.getProfileInfo().then(profile => {
            setDisplayName(profile.displayName ?? '');
          });
        }, [identityApi]);


        return (
          <Page themeId="home">
            <Header title={`Welcome, ${displayName}`}/>
            <Content>
              <CustomHomepageGrid 
                config={[
                  { component: 'LogoWidget',    x: 0, y: 0, width: 3, height: 5, resizable: false },
                  { component: 'MaxxWidget',     x: 3, y: 0, width: 3, height: 5, resizable: false },
                  { component: 'MexxiWidget',     x: 6, y: 0, width: 3, height: 5, resizable: false },
                  { component: 'WelcomeWidget',  x: 9, y: 0, width: 3, height: 5, resizable: false },
                  { component: 'ToolkitWidget',  x: 0, y: 5, width: 4, height: 6, resizable: false },
                  { component: 'AnnouncementWidget',  x: 4, y: 5, width: 4, height: 6, resizable: true },
                ]}
                cols={{
                  xl: 12,
                  lg: 12,
                  md: 6,
                  sm: 6,
                  xs: 3,
                  xxs: 3,
                }}
                breakpoints={{
                  xl: 1200,
                  lg: 1000,
                  md: 480,
                  sm: 480,
                  xs: 480,
                  xxs: 0,
                }}               
                rowHeight={60}
                compactType="vertical"
                preventCollision={false}
                containerPadding={[0, 0]}
                containerMargin={[8, 8]}
              >
                {widgets.map((widget, index) => (
                  <Fragment key={widget.name ?? index}>
                    {widget.component}
                  </Fragment>
                ))}
              </CustomHomepageGrid>
            </Content>
          </Page>
        );
      },
  },
}) as any;